import React from "react";

interface CardFormacionProps {
  imageSrc: string;
  imageAlt?: string;
  title: string;
  linkText: string;
  linkHref: string;
}

export const CardFormacion: React.FC<CardFormacionProps> = ({
  imageSrc,
  imageAlt = "",
  title,
  linkText,
  linkHref,
}) => {
  return (
    <div className="card">
      <div className="card-image-container">
        <img src={imageSrc} alt={imageAlt} className="card-image" />
      </div>

      <div className="card-content">
        <h3 className="card-title">{title}</h3>
        <a target="_blank" href={linkHref}  className="card-link">
          {linkText}
        </a>
      </div>
    </div>
  );
};